import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const pencilIcon: SvgIconData = {
  viewBox: '1 1 93 93',
  element: (
    <path d="m93.5 12.6-11-11.1a2 2 0 0 0-1.2-.5l-1.1.5L6.3 75.3 6 76 1.1 92a1.6 1.6 0 0 0 1.5 2h.5l16-5 .6-.3 73.8-73.9a1.6 1.6 0 0 0 0-2.2M10.3 75.9l63.9-64 8.8 9-63.9 63.8Zm-1.8 2.7 8 8L5 90Zm76.8-60-8.9-8.9L81.3 5l8.8 8.8Z" />
  ),
};
